import React from 'react';
import { checkoutUrl } from '../data/content';
interface CheckoutButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CheckoutButton({
  children,
  className = ''
}: CheckoutButtonProps) {
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className={`block w-full animate-pulse-ring rounded-lg bg-brand-green px-3 py-3 text-center font-heading text-[15px] uppercase leading-tight tracking-wide text-brand-navy shadow-[0_5px_0_0_#749A00] transition duration-150 hover:-translate-y-0.5 hover:bg-[#9DCC00] focus:outline-none focus:ring-4 focus:ring-brand-green/40 active:translate-y-0.5 active:shadow-[0_2px_0_0_#749A00] sm:text-lg ${className}`} data-id="element-35" data-mp="1rl3zgvv7iok8">
      {children}
    </a>;
}